import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";

const deleteIcon = require("./../assets/img/delete-icon.svg").default;

const CustomizeStore = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const { id } = useParams();
  const logoImageBtnRef = useRef();
  const coverImageBtnRef = useRef();

  const [addFormData, setAddFormData] = useState({
    advertisingText: null,
    facecbook: null,
    linkedin: null,
    twitter: null,
    instagram: null,
    youtube: null,
    about: "",
    paymentTerms: "",
    shippingTerms: "",
    privacyPolicy: "",
    contactAddress: "",
    tax: "",
    currency: "₹",
  });
  const [sizeArray, setSizeArray] = useState([]);
  const [signupStatus, setSignupStatus] = useState("");
  const [uploadLogoImage, setUploadLogoImage] = useState();
  const [uploadCoverImage, setUploadCoverImage] = useState();
  const [logoImagePath, setLogoImagePath] = useState(null);
  const [coverImagePath, setCoverImagePath] = useState(null);
  const [imageError, setImageError] = useState();
  const [loading, setLoading] = useState();
  const [addBtnDis, setAddBtnDis] = useState();
  const [images, setImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [imagesPath, setImagesPath] = useState([]);
  const [allDetails, setAllDetails] = useState();
  const currency = ["₹"];

  const handleChange = event => {
    const { name, value } = event.target;

    setAddFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const openLogoPicker = () => {
    if (logoImageBtnRef.current) {
      logoImageBtnRef.current.value = "";
      logoImageBtnRef.current.click();
    }
  };

  const openCoverPicker = () => {
    if (coverImageBtnRef.current) {
      coverImageBtnRef.current.value = "";
      coverImageBtnRef.current.click();
    }
  };

  const fetchStoreDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/${user?.store}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData.data);
        setAddFormData({
          advertisingText: responseData.data.advertisement,
          facecbook: responseData.data.facebook,
          linkedin: responseData.data.linkedin,
          twitter: responseData.data.twitter,
          instagram: responseData.data.instagram,
          youtube: responseData.data.youtube,
          about: responseData.data.about,
          paymentTerms: responseData.data.payment_terms,
          shippingTerms: responseData.data.shipping_terms,
          privacyPolicy: responseData.data.privacy_policy,
          contactAddress: responseData.data.contact_address,
          tax: responseData.data.tax,
          currency: responseData.data.currency,
        });
        setLogoImagePath(responseData.data.logo || null);
        setCoverImagePath(responseData.data.cover || null);
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const onImageMutipleUpload = e => {
    const allowedExtensions = ["jpg", "jpeg", "png"];
    const files = e.target.files;

    if (files.length > 0) {
      Array.from(files).forEach(file => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setNewImages(prev => [...prev, file]);
        } else {
          setImageError(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
        }
      });
    }
  };

  const handleRemoveImage = index => {
    let tempNewArray = [...newImages];
    let newArray = tempNewArray.filter((item, i) => index !== i);
    setNewImages(newArray);
  };

  const deleteLogoImage = async () => {
    setUploadLogoImage(null);
    setLogoImagePath(null);
    try {
      const response = await fetch(`${API_BASE_URL}stores/logo`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const deleteCoverImage = async () => {
    setUploadCoverImage(null);
    setCoverImagePath(null);
    try {
      const response = await fetch(`${API_BASE_URL}stores/cover`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const onImageLogoUploadChange = e => {
    const allowedExtensions = ["jpg", "jpeg", "png", "avif", "webp"];
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadLogoImage(file);
        setLogoImagePath(null);
        setSignupStatus("");
      } else {
        setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
      }
    }
  };

  const onImageCoverUploadChange = e => {
    const allowedExtensions = ["jpg", "jpeg", "png", "avif", "webp"];
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadCoverImage(file);
        setCoverImagePath(null);
        setSignupStatus("");
      } else {
        setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
      }
    }
  };

  const onEditShop = async () => {
    if (addFormData.advertisingText === null || addFormData.advertisingText === undefined || addFormData.advertisingText === "") {
      setSignupStatus(langJson?.advertisingtextisrequired);
      // } else if (addFormData.facecbook === null || addFormData.facecbook === undefined || addFormData.facecbook === "") {
      //   setSignupStatus(langJson?.facecbookfieldisrequired);
      // } else if (addFormData.linkedin === null || addFormData.linkedin === undefined || addFormData.linkedin === "") {
      //   setSignupStatus(langJson?.linkedinfieldisrequired);
      // } else if (addFormData.twitter === null || addFormData.twitter === undefined || addFormData.twitter === "") {
      //   setSignupStatus(langJson?.twitterfieldisrequired);
      // } else if (addFormData.instagram === null || addFormData.instagram === undefined || addFormData.instagram === "") {
      //   setSignupStatus(langJson?.instagramfieldisrequired);
      // } else if (addFormData.youtube === null || addFormData.youtube === undefined || addFormData.youtube === "") {
      //   setSignupStatus(langJson?.youtubefieldisrequired);
      //   } else if (!addFormData.paymentTerms) {
      //     setSignupStatus(langJson?.paymenttermsisrequired);
      //   } else if (!addFormData.shippingTerms) {
      //     setSignupStatus(langJson?.shippingtermsisrequired);
      //   } else if (!addFormData.tax) {
      //     setSignupStatus(langJson?.taxisrequired);
      // } else if (!uploadLogoImage) {
      //   setSignupStatus(langJson?.logoimageisrequired);
      // } else if (!uploadCoverImage) {
      //   setSignupStatus(langJson?.coverimageisrequired);
    } else {
      setSignupStatus("");
      setAddBtnDis(true);
      const fd = new FormData();

      if (uploadLogoImage) {
        fd.append("logo", uploadLogoImage);
      } else if (!logoImagePath) {
        fd.append("logo", "");
      }

      if (uploadCoverImage) {
        fd.append("cover", uploadCoverImage);
      } else if (!coverImagePath) {
        fd.append("cover", "");
      }

      fd.append("advertisement", addFormData.advertisingText ? addFormData.advertisingText : "");
      fd.append("facebook", addFormData.facecbook ? addFormData.facecbook : "");
      fd.append("linkedin", addFormData.linkedin ? addFormData.linkedin : "");
      fd.append("twitter", addFormData.twitter ? addFormData.twitter : "");
      fd.append("instagram", addFormData.instagram ? addFormData.instagram : "");
      fd.append("youtube", addFormData.youtube ? addFormData.youtube : "");
      fd.append("tax", addFormData.tax ? addFormData.tax : 0);
      fd.append("currency", addFormData.currency ? addFormData.currency : "₹");
      fd.append("about", addFormData.about ? addFormData.about : "");
      fd.append("payment_terms", addFormData.paymentTerms ? addFormData.paymentTerms : "");
      fd.append("shipping_terms", addFormData.shippingTerms ? addFormData.shippingTerms : "");
      fd.append("privacy_policy", addFormData.privacyPolicy ? addFormData.privacyPolicy : "");
      fd.append("contact_address", addFormData.contactAddress ? addFormData.contactAddress : "");
      fd.append("lang", selectedLanguage);

      try {
        const response = await fetch(`${API_BASE_URL}stores/${user?.store}`, {
          method: "POST",
          body: fd,
          headers: {
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          setSignupStatus(responseData.msg);
          setAddBtnDis(false);
        } else {
          setSignupStatus(responseData.msg);
          setAddBtnDis(false);
        }
      } catch (error) {
        console.error("Error during Sign UP:", error);
        setAddBtnDis(false);
      }
    }
  };

  useEffect(() => {
    fetchStoreDetails();
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide">
          <h2>{langJson?.customizeyourstore}</h2>
          <ul className="addAddress">
            <li>
              <label>{langJson?.advertisingtext}</label>
              <input type="text" name="advertisingText" onChange={handleChange} value={addFormData.advertisingText} />
            </li>
            <li>
              <label>{langJson?.facecbook}</label>
              <input type="text" name="facecbook" onChange={handleChange} value={addFormData.facecbook} />
            </li>
            <li>
              <label>{langJson?.linkedin}</label>
              <input type="text" name="linkedin" onChange={handleChange} value={addFormData.linkedin} />
            </li>
            <li>
              <label>Whatsapp</label>
              <input type="text" name="twitter" onChange={handleChange} value={addFormData.twitter} />
            </li>
            <li>
              <label>{langJson?.instagram}</label>
              <input type="text" name="instagram" onChange={handleChange} value={addFormData.instagram} />
            </li>
            <li>
              <label>{langJson?.youtube}</label>
              <input type="text" name="youtube" onChange={handleChange} value={addFormData.youtube} />
            </li>
            <li>
              <label>{langJson?.tax}(%):</label>
              <input type="text" name="tax" value={addFormData.tax} onChange={handleChange} />
            </li>
            <li>
              <label>{langJson?.currency}</label>
              <select name="currency" onChange={handleChange} value={addFormData.currency}>
                {currency?.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </li>
            <li className="fullWidth">
              <label>{langJson?.aboutus}:</label>
              <textarea name="about" value={addFormData.about} onChange={handleChange} />
            </li>
            <li className="fullWidth">
              <label>{langJson?.paymentterms}:</label>
              <textarea name="paymentTerms" value={addFormData.paymentTerms} onChange={handleChange} />
            </li>
            <li className="fullWidth">
              <label>{langJson?.shippingterms}:</label>
              <textarea name="shippingTerms" value={addFormData.shippingTerms} onChange={handleChange} />
            </li>
            <li className="fullWidth">
              <label>{langJson?.imprintprivacypolicy}:</label>
              <textarea name="privacyPolicy" value={addFormData.privacyPolicy} onChange={handleChange} />
            </li>
            <li className="fullWidth">
              <label>{langJson?.contactaddress || "Contact Address"}:</label>
              <textarea name="contactAddress" value={addFormData.contactAddress} onChange={handleChange} />
            </li>
            <li className="fullWidth">
              <label>{langJson?.logoimage}:</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.avif,.webp,image/jpeg,image/png,image/avif,image/webp"
                ref={logoImageBtnRef}
                hidden
                onChange={e => onImageLogoUploadChange(e)}
              />
              <button
                className="imageSelectBtn"
                type="button"
                disabled={uploadLogoImage || logoImagePath ? true : false}
                onClick={openLogoPicker}
              >
                {langJson?.chooselogoimage || "Choose logo image"}
              </button>
              {uploadLogoImage || logoImagePath ? (
                <div className="coverPreviewWrap">
                  <img className="coverPreviewImg" src={uploadLogoImage ? URL.createObjectURL(uploadLogoImage) : IMAGE_URL + logoImagePath} />
                  <img className="coverPreviewDelete" src={deleteIcon} alt="" onClick={() => deleteLogoImage()} />
                </div>
              ) : null}
            </li>
            <li className="fullWidth">
              <label>{langJson?.coverimage}:</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.avif,.webp,image/jpeg,image/png,image/avif,image/webp"
                ref={coverImageBtnRef}
                hidden
                onChange={e => onImageCoverUploadChange(e)}
              />
              <button
                className="imageSelectBtn"
                type="button"
                disabled={uploadCoverImage || coverImagePath ? true : false}
                onClick={openCoverPicker}
              >
                {langJson?.choosecoverimage}
              </button>
              {uploadCoverImage || coverImagePath ? (
                <div className="coverPreviewWrap coverPreviewWrapWide">
                  <img className="coverPreviewImg coverPreviewImgWide" src={uploadCoverImage ? URL.createObjectURL(uploadCoverImage) : IMAGE_URL + coverImagePath} />
                  <img className="coverPreviewDelete" src={deleteIcon} alt="" onClick={() => deleteCoverImage()} />
                </div>
              ) : null}
            </li>
            <li className="fullWidth saveBtn">
              <button type="button" disabled={addBtnDis} onClick={() => onEditShop()}>
                {addBtnDis ? langJson?.pleasewait : langJson?.savechanges}
              </button>
            </li>
            <span className="lgnStatus">{signupStatus}</span>
          </ul>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default CustomizeStore;
